/**
 * Derives the canonical hardwareId for a Cannes device.
 *
 * Contract (per blueapi `/devices/{hardwareId}/assign/complete`):
 * - Format: `modelName_serialNumber`
 * - Whitespace within modelName or serialNumber is replaced with `_`
 * - No other normalization (case is preserved as-is)
 * - Both inputs must be non-empty; otherwise returns `undefined`
 *
 * This function is the single source of truth for hardwareId derivation.
 * Both registration (complete assignment) and unassign must use this helper
 * to ensure the same hardwareId is produced regardless of code path.
 *
 * @example
 * ```ts
 * deriveHardwareId('Zeiss_DS-N4K', 'DEV-2025-00042')
 * // → 'Zeiss_DS-N4K_DEV-2025-00042'
 * ```
 *
 * @example
 * ```ts
 * deriveHardwareId('Soluna DS-N4K', '4.5-36x40')
 * // → 'Soluna_DS-N4K_4.5-36x40'
 * ```
 */
export const deriveHardwareId = (modelName: string | undefined | null, serialNumber: string | undefined | null): string | undefined => {
  if (!modelName || !serialNumber) {
    return undefined;
  }

  return `${modelName}_${serialNumber}`.replaceAll(/\s+/g, '_');
};
